import { getProductsForCollection } from "../client";
import { useQuery } from "@tanstack/react-query";
import { CollectionRow } from "../models";

/**
 * Returns all products for a collection.
 */
export function useProductsForCollection(collection: CollectionRow | null) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["collections", collection?.id, "products"],
    queryFn: () => {
      if (!collection?.requires_purchase) {
        return [];
      }
      return getProductsForCollection(collection.id);
    },
  });

  return { products: data, isLoading, error };
}
